import useTranslation from "@/hooks/useTranslation";
import MetricWidget from "../../components/MetricWidget/MetricWidget";
import { ImpactMetric } from "../../utils/types";
import { usePackagingImpactTotals } from "@/pages/dashboard/hooks/usePackagingImpact";

export default function PackagingImpactTotal({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = usePackagingImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  return (
    <MetricWidget
      title={"Packaging footprint"}
      tooltip={translation["dashboard"]["packaging"]["total"]}
      loading={isLoading || isFetching}
      format={metric.formatter}
      metric={metric}
      data={{
        value: data?.packaging_impact[metric.key],
        comparison: {
          label: "of company total",
          value: data?.company_impact[metric.key],
        },
      }}
    />
  );
}
